import React from 'react';
import SlickSlider from './SlickSlider ';
export default function Certificate() {
  return (
    <SlickSlider/>
  )
}
